import { useCallback } from 'react';

import {
  AdminFonctionnelControllerApi,
  RecuperationActiviteUtilisateurRequestDto,
  RecuperationActiviteUtilisateurViolationsDto,
  RecuperationActiviteUtilisateurViolationsDtoFormFieldEnum,
} from 'lib_api/lib/api/gen';

import { useValidateField } from 'hooks/utils/handleValidationRequest';

import { RecuperationActiviteUtilisateurFormValues } from '../types';
import { mapRecuperationActiviteUtilisateurFormValuesToRequest } from '../utils';

export function useValidateRecuperationActiviteUtilisateurForm(
  controller: AdminFonctionnelControllerApi,
): (
  field: RecuperationActiviteUtilisateurViolationsDtoFormFieldEnum,
  changedValues: RecuperationActiviteUtilisateurFormValues,
) => Promise<void> {
  const sendRequest = useCallback(
    async (
      field: RecuperationActiviteUtilisateurViolationsDtoFormFieldEnum,
      changedValues: RecuperationActiviteUtilisateurRequestDto,
    ): Promise<RecuperationActiviteUtilisateurViolationsDto> => {
      const response =
        await controller.validationRecuperationActiviteUtilisateurFieldUsingPOST(
          field,
          changedValues,
        );
      return response[0];
    },
    [controller],
  );

  const extractor = useCallback(
    (
      response: RecuperationActiviteUtilisateurViolationsDto,
    ): RecuperationActiviteUtilisateurViolationsDto[] => {
      return response ? [response] : [];
    },
    [],
  );

  return useValidateField(
    mapRecuperationActiviteUtilisateurFormValuesToRequest,
    sendRequest,
    extractor,
  ).validate;
}
